import { useState } from 'react'
import { Alert, Button, Container, Paper, TextField, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import sessionStore from '../stores/sessionStore'
import { authErrorMessage } from '../auth/authErrors'

export default function VerificationPending() {
	const location = useLocation()
	const navigate = useNavigate()
	const [email, setEmail] = useState(location.state?.email || '')
	const [loading, setLoading] = useState(false)
	const [message, setMessage] = useState('Проверьте почту и перейдите по ссылке подтверждения.')
	const [error, setError] = useState('')

	const resend = async () => {
		if (loading) return
		setLoading(true); setError('')
		try {
			await sessionStore.resendVerification(email)
			setMessage('Если аккаунт существует, письмо отправлено повторно.')
		} catch (reason) { setError(authErrorMessage(reason)) }
		finally { setLoading(false) }
	}

	return <Container maxWidth='xs'><Paper sx={{ p: 3, mt: 5 }}>
		<Typography variant='h5'>Подтвердите электронную почту</Typography>
		<Alert severity='info' sx={{ my: 2 }}>{message}</Alert>
		{error && <Alert severity='error'>{error}</Alert>}
		<TextField fullWidth label='Электронная почта' value={email} onChange={event => setEmail(event.target.value)} sx={{ my: 2 }} />
		<Button fullWidth variant='contained' disabled={loading || !email} onClick={resend}>Отправить повторно</Button>
		<Button fullWidth sx={{ mt: 1 }} onClick={() => navigate('/login')}>Перейти ко входу</Button>
	</Paper></Container>
}
